/**
 * 파일명 : com0113p.jsx
 * 설명 : 직원보조부서선택
 * 수정내역
 ************************************************
 * Version    수정일자      수정자    수정내용      
 ************************************************
 */


/************************************************
 * Import 영역
 ************************************************/
/* React */
import React from 'react';

/* AntD */
import { Layout, Row, Col, Space, Button, Select, Switch, Table } from 'antd';

/* Reducer */
import { useAppSelector, useAppDispatch } from '../../../redux/hooks';
import { Com0113pAction } from '../../../redux/slice/com/com0113p_slice';
import { IDeptState, IDutyCdState } from '../../../redux/models/com/com0113p_model';

/* 업무 */
import * as commonProxy from 'libs/CommonProxy';
import * as common from 'libs/common';


/************************************************
 * 전역변수 선언영억
 ************************************************/
const Com0113p = (props:any) => {
    /**
     * 기능 : State / Reducer 선언
     * param : 
     */
    const dispatch    = useAppDispatch();
    const deptList    = useAppSelector((state) => state.Com0113p.deptList);
    const dutyCdList  = useAppSelector((state) => state.Com0113p.dutyCdList);

    /************************************************
     * 이벤트 함수 영역
     ************************************************/
    /**
     * 기능 : onClick 이벤트 선언
     * param : 
     */
    const onClick = async (e:any) => {
        const buttonName = e.currentTarget.name;
        switch (buttonName) {
            case 'btnAdd': {
                const callback = (datas:IDeptState[]) => {
                    if (!datas) return;
                    let tempDatas = [];
                    for (let i = 0; i < datas.length; i++) {
                        const data = { ...datas[i] };

                        if (data.deptCd === props.deptCd) {
                            const param = {
                                title : '위드정보 확인',
                                contents: '메인부서와 같은 부서를 보조부서로 선택 할 수 없습니다.',
                            };
                            common.openInfo(param);
                            return false;
                        }

                        const isExists = deptList.filter((item:IDeptState) => {
                            return item.deptCd === data.deptCd;
                        });
                        if (isExists.length > 0) continue;

                        tempDatas.push(data);
                    }
                    for (let i = 0; i < tempDatas.length; i++) {
                        const data = { ...tempDatas[i] };
                        dispatch(Com0113pAction.addToDeptList(data));
                    }
                }
                const params:any = {};
                params.title = '부서조회';
                params.width = 700
                params.popupId = 'com0114p';
                params.accept = callback;
                common.openPopup(params);
                break;
            }
            case 'btnDel': {
                dispatch(Com0113pAction.setDeptList([]));
                break;
            }
            case 'btnClose': {
                props.cancel();
                break;
            }
            case 'btnOk': {
                if (!props.empNo) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '사용자 등록 후 저장 해 주세요.',
                    };
                    common.openInfo(param);
                    return false;
                }
                else if (!props.deptCd) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '메인부서 등록 후 저장 해 주세요.',
                    };
                    common.openInfo(param);
                    return false;
                }

                const filterd = deptList.filter(item => {
                    return common.isEmptyString(item.dutyCd);
                });

                if (filterd.length > 0) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '직책을 선택하세요.',
                    };
                    common.openInfo(param);
                    return false;
                }

                /* 변수선언 및 셋팅 영역 */
                // 입력파라미터
                const requestData = {
                    empNo : props.empNo,
                    empDepts : deptList
                };

                /* 트렌젝션 호출 및 결과 셋팅 */
                commonProxy.callAsyncSvc(requestData, {
                    txCd: 'TRUSRS0008',
                    success: (_:any) => {
                        const param = {
                            title : '위드정보 확인',
                            contents: '정상적으로 처리되었습니다.',
                        };
        
                        common.openAlert(param);
                    },
                });

                break;
            }
            default:
        }
    };

    /************************************************
     * 개발자함수 영역
     ************************************************/
    

    /************************************************
     * Render 변수 선언 및 셋팅영역
     ************************************************/
     /* Render 변수 선언영역 */
     /* AntD */
     const { Content } = Layout;
     const { Option } = Select;


    /**
     * 기능 : componentDidMount
     * 설명 : 화면 최초 로드시에 필요한 기능을 구현한다.
     * param : 
     * return : None
     **/
     React.useEffect(() => {
        const option = {
            useYn: 'Y',
            callback: (datas:IDutyCdState[]) => {
                let arrOptions:IDutyCdState[] = [];
                datas.forEach((item:IDutyCdState) => {
                    arrOptions.push({
                        label: item.cdNm,
                        value: item.cd
                    });
                });

                dispatch(Com0113pAction.setDutyCdList(arrOptions));

                /* 변수선언 및 셋팅 영역 */
                // 입력파라미터
                const requestData = {
                    empNo : props.empNo,
                    mainDeptYn : 'N',
                };

                /* 트렌젝션 호출 및 결과 셋팅 */
                commonProxy.callAsyncSvc(requestData, {
                    txCd: 'TRUSRR0006',
                    success: (responseData:any) => {
                        dispatch(Com0113pAction.setDeptList(responseData.empDeptItems));
                    },
                });
            }
        };
        common.getComCodeList('012', option);

        return () => {
            dispatch(Com0113pAction.setDeptList([]));
        }
    }, []);

    /* Table Columns */
    const columns = React.useCallback(() => {
        const arr:any = [
            {
                title: () => <div style={{ textAlign: 'center', width: 100 }}>부서코드</div>,
                dataIndex: 'deptCd',
                key: 'deptNm',
                align: 'center',
            },
            {
                title: () => <div style={{ textAlign: 'center', width: 250 }}>부서명</div>,
                dataIndex: 'deptNm',
                key: 'deptNm',
                align: 'center',
            },
            {
                title: () => <div style={{ textAlign: 'center', width: 200 }}>직책</div>,
                dataIndex: 'dutyCd',
                key: 'dutyCd',
                align: 'center',
                render: (_:string, record:IDeptState) => {
                    const handleChange = (item:string) => {
                        const data:IDeptState = { ...record, dutyCd: item };
                        dispatch(Com0113pAction.setDeptItem(data));
                    }
    
                    const switchChange = (item:boolean) => {
                        const data:IDeptState = { ...record, deptHdrYn: item ? 'Y' : 'N' };
                        dispatch(Com0113pAction.setDeptItem(data));
                    }
    
                    const options = dutyCdList.map((item:IDutyCdState) => {
                        return (<Option key={item.value} value={item.value}>{item.label}</Option>);
                    });
                    return (
                        <Space>
                            <Select disabled={!common.isAdmin()} style={{ width: 100 }} onChange={handleChange} value={record.dutyCd}>{options}</Select>
                            <Switch id='swDeptHdrYn' checkedChildren='부서장' unCheckedChildren='부서원' checked={record.deptHdrYn === 'Y'} onChange={(isChecked) => {
                                switchChange(isChecked);
                            }} />
                        </Space>
                    )
                },
            }];
            return arr;
    }, [dutyCdList]);

    return (
        /* 화면 디자인 영역*/
        <Layout>
            <Content>
                <Space size='small' direction='vertical'>
                    {common.isAdmin() ?
                    <Row justify='end'>
                        <Col>
                            <Space>
                                <Button size='small' name='btnAdd' className='background-color-default-button' onClick={onClick}>추가</Button>
                                <Button size='small' name='btnDel' className='background-color-default-button' onClick={onClick}>초기화</Button>
                            </Space>
                        </Col>
                    </Row> : null}
                    <Table
                        dataSource={deptList}
                        key='deptList'
                        rowKey='deptCd'
                        columns={columns()}
                        size='small'
                        style={{width:'500'}}
                        scroll={{x:150}}
                        pagination={false}
                    />
                </Space>
                <Row justify='center' style={{ marginTop: 20 }}>
                    <Space size='small'>
                        <Col>
                            <Button
                                name='btnClose'
                                className='background-color-default-button'
                                onClick={onClick}
                            >
                                닫기
                            </Button>
                        </Col>
                        {common.isAdmin() ?
                        <Col>
                            <Button
                                name='btnOk'
                                className='background-color-primary-button'
                                onClick={onClick}
                            >
                                저장
                            </Button>
                        </Col> : null}
                    </Space>
                </Row>
            </Content>
        </Layout>
    );
}

export default Com0113p;